"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "toolbar" };
var vue_3 = require("vue");
var element_plus_1 = require("element-plus");
var vue_router_1 = require("vue-router");
var AsideComponent_vue_1 = __importDefault(require("./components/AsideComponent.vue"));
var HeaderComponent_vue_1 = __importDefault(require("./components/HeaderComponent.vue"));
var store_1 = require("@/store");
exports.default = (0, vue_1.defineComponent)({
    __name: 'indexView',
    setup: function (__props) {
        var route = (0, vue_router_1.useRoute)();
        var router = (0, vue_router_1.useRouter)();
        var mainStore = (0, store_1.useMainStore)();
        var routeKey = route.name;
        var userData = (0, vue_3.ref)({ user_name: "", user_account: "" });
        var loading = element_plus_1.ElLoading.service({
            lock: true,
            text: '界面加载中，请稍候...',
            background: 'rgba(0, 0, 0, 0.7)',
        });
        setTimeout(function () {
            var user_data = localStorage.getItem("user_data");
            userData.value = user_data && user_data !== 'undefined' ? JSON.parse(user_data) : { user_name: "", user_account: "" };
            loading.close();
            if (!userData.value.user_account) {
                (0, element_plus_1.ElNotification)({
                    title: '登录信息丢失',
                    message: '登录用户信息失效，请重新登录',
                    type: 'error',
                });
                router.push({ path: "/login" });
            }
        }, 500);
        return function (_ctx, _cache) {
            var _component_el_scrollbar = (0, vue_2.resolveComponent)("el-scrollbar");
            var _component_el_aside = (0, vue_2.resolveComponent)("el-aside");
            var _component_el_header = (0, vue_2.resolveComponent)("el-header");
            var _component_el_collapse_transition = (0, vue_2.resolveComponent)("el-collapse-transition");
            var _component_router_view = (0, vue_2.resolveComponent)("router-view");
            var _component_el_main = (0, vue_2.resolveComponent)("el-main");
            var _component_el_container = (0, vue_2.resolveComponent)("el-container");
            var _directive_watermark = (0, vue_2.resolveDirective)("watermark");
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_container, {
                class: "layout-container-demo",
                style: { "height": "100vh" }
            }, {
                default: (0, vue_2.withCtx)(function () { return [
                    (0, vue_2.createVNode)(_component_el_aside, {
                        width: (0, vue_2.unref)(mainStore).isCollapse ? '64px' : '200px'
                    }, {
                        default: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.createVNode)(_component_el_scrollbar, null, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createVNode)(AsideComponent_vue_1.default)
                                ]; }),
                                _: 1
                            })
                        ]; }),
                        _: 1
                    }, 8, ["width"]),
                    (0, vue_2.createVNode)(_component_el_container, null, {
                        default: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.createVNode)(_component_el_header, null, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                                        (0, vue_2.createVNode)(HeaderComponent_vue_1.default)
                                    ])
                                ]; }),
                                _: 1
                            }),
                            (0, vue_2.createVNode)(_component_el_main, null, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    ((0, vue_2.unref)(userData).user_account)
                                        ? (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_scrollbar, { key: 0 }, {
                                            default: (0, vue_2.withCtx)(function () { return [
                                                (0, vue_2.createVNode)(_component_router_view, null, {
                                                    default: (0, vue_2.withCtx)(function (_a) {
                                                        var Component = _a.Component;
                                                        return [
                                                            (0, vue_2.createVNode)(_component_el_collapse_transition, null, {
                                                                default: (0, vue_2.withCtx)(function () { return [
                                                                    ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)(Component), { key: (0, vue_2.unref)(routeKey) }))
                                                                ]; }),
                                                                _: 2
                                                            }, 1024)
                                                        ];
                                                    }),
                                                    _: 1
                                                })
                                            ]; }),
                                            _: 1
                                        })), [
                                            [_directive_watermark, (0, vue_2.unref)(userData).user_account + '-' + (0, vue_2.unref)(userData).user_name]
                                        ])
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]; }),
                                _: 1
                            })
                        ]; }),
                        _: 1
                    })
                ]; }),
                _: 1
            }));
        };
    }
});
